/**
 * Backfill Account Info Schema
 *
 * POST /api/oauth/connection/:connectionId/backfill-account-info
 * Fetches and stores user info for connections missing email/name/avatar
 */

import { z } from "zod";

/**
 * Path variables for backfilling account info
 */
export const BackfillAccountInfoPathVarsSchema = z.object({
  connectionId: z.string().uuid()
});

/**
 * Response for backfilling account info
 * Success indicated by ApiSuccess wrapper
 */
export const BackfillAccountInfoResponseSchema = z.object({
  accountEmail: z.string().nullable()
});
